export default __webpack_public_path__ + "static/media/mb-welcome.d24eba0b.mp4";